export default "__VITE_ASSET__c8Df7srC__"